import { getFunctions, httpsCallable } from 'firebase/functions';

/** If this Google/email session matches a pending architect invite, write role=architect. */
export async function attachPendingArchitectInvite(): Promise<boolean> {
  try {
    const fn = httpsCallable<Record<string, never>, { attached?: boolean }>(
      getFunctions(undefined, 'us-central1'),
      'acceptCrmInvite',
    );
    const { data } = await fn({});
    return data?.attached === true;
  } catch {
    return false;
  }
}
